import React from 'react';
import { Eye, Edit, Lock } from 'lucide-react';

const PaymentsTable = ({
  payments,
  filterStatus,
  searchNotFound,
  searchTerm,
  paymentsLoading,
  paymentByIdLoading,
  handleViewDetails,
  handleEditClick,
  handleClearSearch,
  getStatusBadgeColor
}) => {
  // Filter payments based on status
  const filteredPayments = payments.filter(p => filterStatus === 'all' || p.status === filterStatus);

  if (paymentsLoading || paymentByIdLoading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <p className="mt-2 text-gray-600">Loading payments...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden h-full flex flex-col">
      <div className="flex-1 min-h-0 overflow-auto">
        <table className="min-w-full">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Payment ID
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Invoice No
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                License ID
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Total
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Paid
              </th>
              <th className="px6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Balance
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Status
              </th>
              <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {filteredPayments.length > 0 ? (
              filteredPayments.map((payment, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    {payment.payment_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    {payment.invoice_no}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    {payment.license_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    LKR {payment.total_amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    LKR {payment.paid_amount}
                  </td>
                  <td className="px6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                    LKR {payment.balance_amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-left">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadgeColor(payment.status)}`}>
                      {payment.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-left">
                    <div className="flex space-x-2">
                      <button 
                        onClick={() => handleViewDetails(payment)}
                        className="text-blue-600 hover:text-blue-800 p-1 hover:bg-blue-50 rounded transition-colors"
                        title="View Details"
                      >
                        <Eye size={16} />
                      </button>
                      {payment.status === 'Paid' ? (
                        <button 
                          className="text-gray-400 p-1 cursor-not-allowed"
                          title="Cannot edit paid payments"
                          disabled
                        >
                          <Lock size={16} />
                        </button>
                      ) : (
                        <button 
                          onClick={() => handleEditClick(payment)}
                          className="text-green-600 hover:text-green-800 p-1 hover:bg-green-50 rounded transition-colors"
                          title="Edit Payment"
                        >
                          <Edit size={16} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="px-6 py-8 text-center text-gray-500">
                  {searchNotFound || searchTerm ? 
                    'No payments match your search' : 
                    'No payments found'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentsTable;